/**
 * React-native 라우트의 단일 진실.
 *
 * 본 프로젝트는 Vue → React 마이그레이션 중인 hybrid SPA 다.
 * 모든 라우트는 Pinia state 보존을 위해 `VueBridgeLayout` 안에서 mount 되지만,
 * React-native 페이지(아래 prefix 로 시작하는 경로)에서는 사용자에게 React 컴포넌트가 보이고
 * Vue 앱은 사이드이펙트 채널(메모리 라우터)일 뿐이다.
 *
 * React-native 페이지에서는 Vue 메모리 라우터의 path 변경이 React Router URL 을 끌고
 * 가서는 안 되며, `isReactNativePath` 는 `VueBridgeLayout.deriveNavView` 의 visual
 * tree 숨김 기준으로도 쓰인다.
 *
 * `/auth/error` 는 Vue App 안에서 에러 페이지를 렌더링하므로 visual tree 를 숨기면
 * 안 된다. 대신 React Router URL 만 보호하기 위해 `shouldSuppressVueRouterSync` 에서
 * 별도로 다룬다.
 *
 * 새 React-native 페이지를 추가할 때 이 파일은 가드(`afterEachGuard`) 와 `deriveNavView`
 * 에 대한 단일 진실 역할을 한다. 단, 다음 두 곳은 lazy import 가 필요해 자동 동기화가
 * 어렵고 수동 유지 대상이다 — 새 페이지 추가 시 함께 갱신해야 한다:
 *
 *   1. `frontend/src/react/router/AppRouter.tsx` — 실제 `<Route>` 선언
 *   2. `frontend/src/react/router/routeConfig.ts` — 인증 요구사항 메타 인벤토리
 */
export const REACT_NATIVE_PATH_PREFIXES = [
  "/range-explorer",
  "/card-mnemonic",
  "/documents",
  "/game",
  "/play",
  "/settings",
  "/solve",
] as const;

export const VUE_ROUTER_SYNC_SUPPRESSED_PATH_PREFIXES = [
  ...REACT_NATIVE_PATH_PREFIXES,
  "/auth/error",
] as const;

function hasPathPrefix(pathname: string, prefixes: readonly string[]): boolean {
  return prefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + "/")
  );
}

export function isReactNativePath(pathname: string): boolean {
  return hasPathPrefix(pathname, REACT_NATIVE_PATH_PREFIXES);
}

export function shouldSuppressVueRouterSync(pathname: string): boolean {
  return hasPathPrefix(pathname, VUE_ROUTER_SYNC_SUPPRESSED_PATH_PREFIXES);
}
